import {
  CatImageGalleryItem,
  CatIconZoomIn,
  CatButton
} from 'components/blocks-components';
import styles from './product-image-picker.module.scss';
import { Conditional } from '@cat-ecom/pcc-components';
import { OverlayMessage } from 'components/OverlayMessage';

export default function ProductImageGalleryZoomButton({
  image,
  openDrawer,
  thumbnailsImagesFlag,
  isDiscontinued = false
}) {
  return (
    <CatImageGalleryItem>
      <div className={styles['product-image-gallery_container']}>
        <picture>
          <img
            data-part="image"
            alt={image.thumbnailText}
            className={styles['product-image-gallery_actual-image']}
            loading="lazy"
            src={image.src}
            style={{ opacity: isDiscontinued ? '70%' : '100%', minWidth: 343 }}
          />
          {isDiscontinued && <OverlayMessage text={'DISCONTINUED_OVERLAY'} />}
        </picture>
        <Conditional test={thumbnailsImagesFlag} fallback={null}>
          <div className="position-absolute w-auto top-0 end-0 d-md-none">
            <CatButton
              data-testid="zoom-in-drawer-btn"
              hideText
              size="lg"
              onClick={openDrawer}
            >
              <CatIconZoomIn slot="before" />
            </CatButton>
          </div>
        </Conditional>
      </div>
    </CatImageGalleryItem>
  );
}
